module.exports = " <section id=map _v-e7994ffe=\"\"> <div class=map-content _v-e7994ffe=\"\"> <div class=location-name _v-e7994ffe=\"\">{{ conf.location.name }}</div> <div class=location-addr _v-e7994ffe=\"\">{{ conf.location.address }}</div> <ul _v-e7994ffe=\"\"> <li _v-e7994ffe=\"\">{{ conf.location.description1 }}</li> <li _v-e7994ffe=\"\">{{ conf.location.description2 }}</li> </ul> </div> <div id=map-wrapper width=100 height=100 _v-e7994ffe=\"\"></div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e7994ffe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
 ** module id = 70
 ** module chunks = 1
 **/